<template>
  <div class="maintain_cycle_manage-bd tb" v-if="funcView.upkeep_cycle_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <custom-select  url="productCodeSelectList" v-model="formSearch.productCode" :props="{ label: 'productCode', value: 'productCode' }" :placeholder="$t('Common.com_please_select')" width="100%" @change="onPageChange({ page: 1 })"></custom-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="devicel-wrap table-bd">
      <ul class="ubw" style="align-content: flex-start;">
        <li v-for="(item, index) in tableList" :key="index">
          <div class="name ub">
            <h1 class="ub-f1">{{ item.productCode }}</h1>
            <div class="edit" @click="editEvent(item)" v-if="funcView.upkeep_cycle_edit">{{funcView.upkeep_cycle_edit}}</div>
          </div>
          <div class="device ub">
            <div class="img-box">
              <!-- <img
                v-if="item.modelInstructionList[0]"
                :src="item.modelInstructionList[0].attachPath"
                alt
              /> -->
               <img
                  v-if="getAttachUrl(item)"
                  :src="getAttachUrl(item)"
                  alt
                />
            </div>
            <div class="info">
              <h2>
                {{$t('asm_maintain_cycle_manage.bao_yang_jian_ge')}}:
                <span>{{ item.cycleInfo&&item.cycleInfo.maxUsageHour || '-' }}h</span>
              </h2>
              <!-- <p>到达<span>{{item.cycleInfo&&item.cycleInfo.hourWarnTime || '-'}}h</span> ，提醒即将需要保养</p> -->
              <p v-html="hourWarnTimeFilter(item.cycleInfo&&item.cycleInfo.hourWarnTime || '-')" :title="$t('asm_maintain_cycle_manage.ddohtxjjxyby', [item.cycleInfo&&item.cycleInfo.hourWarnTime || '-'])"></p>
              <h2>
                {{$t('asm_maintain_cycle_manage.zcbyjg')}}:
                <span>{{ item.cycleInfo&&item.cycleInfo.maxUsageDay || '-' }}{{$t('asm_maintain_cycle_manage.tian')}}</span>
              </h2>
              <!-- <p>到达 <span>{{item.cycleInfo&&item.cycleInfo.dayWarnTime || '-'}}{{$t('page_content_title_day')}}</span> ，提醒即将需要保养</p> -->
              <p v-html="dayWarnTimeFilter(item.cycleInfo&&item.cycleInfo.dayWarnTime || '-')" :title="$t('asm_maintain_cycle_manage.ddottxjjxyby', [item.cycleInfo&&item.cycleInfo.dayWarnTime || '-'])"></p>
              <h2>
                {{$t('asm_maintain_cycle_manage.bygdcsqx')}}:
                <span>{{ item.cycleInfo&&item.cycleInfo.upkeepOrderTimeout || '-' }}h</span>
              </h2>
              <!-- <p>保养工单超时期限</p> -->
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <maintain-cycle-dialog
      v-if="dialogVisible"
      :data="dialogData"
      :model="dialogModel"
      @close="dialogVisible = false"
      @success="onPageChange({ page: 1 })"
    ></maintain-cycle-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import maintainCycleDialog from './children/maintain_cycle_dialog.vue';

export default {
  components: { maintainCycleDialog },
  name: 'maintain_cycle_manage',
  data() {
    return {
      provide: true,
      formSearch: {
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
        productCode: ''
      },
      tableList: [],
      totalRows: null,

      dialogVisible: false,
      dialogModel: {},
      dialogData: {}
    };
  },

  mounted: function () {
    this.getFuncView();
    this.getCyclePage();
  },
  methods: {
    // 编辑
    editEvent: function (data) {
      this.dialogModel.type = 'edit';
      this.dialogModel.title = this.$t('asm_maintain_cycle_manage.bjbyzq');
      this.dialogModel.data = data.cycleInfo || {};
      this.dialogModel.data.productCode = data.productCode || '';
      this.dialogVisible = true;
    },
    hourWarnTimeFilter: function (hourWarnTime) {
      return this.$t('asm_maintain_cycle_manage.ddspanohspantxjjxyby', [hourWarnTime]);
    },
    dayWarnTimeFilter: function (dayWarnTime) {
      return this.$t('asm_maintain_cycle_manage.ddspanotspantxjjxyby', [dayWarnTime]);
    },
    // 获取设备保养周期分页
    getCyclePage: function () {
      this.$getJSON(apis.ProductCycle, this.formSearch).then((res) => {
        const list = res.data.list;
        // this.tableList = res.data.list;
        this.formatAttachList(list, 'productCodeId', 'dms.product.icon').then((result) => {
          this.tableList = result;
        });
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getCyclePage();
    },

  }
};
</script>

<style lang="scss" scoped>
@import "style/colors.scss";

.maintain_cycle_manage-bd {
  .title {
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    line-height: 32px;
    font-size: 16px;
    float: left;
  }
  .devicel-wrap {
    ul {
      height: 100%;
      overflow-y: auto;
    }
    ul li {
      height: 220px;
      width: 376px;
      margin-right: 16px;
      margin-bottom: 16px;
      border: 1px solid rgba(233, 233, 233, 1);
      .name {
        line-height: 48px;
        height: 48px;
        padding: 0 24px;
        border-bottom: 1px solid rgba(233, 233, 233, 1);
        h1 {
          font-weight: bold;
          color: #262626;
          font-size: 18px;
        }
        .edit {
          cursor: pointer;
          color: #00afff;
          font-size: 14px;
        }
      }
      .device {
        .img-box {
          width: 168px;
          height: 172px;
          padding-top: 16px;
          padding-left: 24px;
          img {
            width: 120px;
            height: 120px;
          }
        }
        .info {
          padding-top: 14px;
          width: 100%;
          overflow: hidden;
          h2 {
            color: #333333;
            font-weight: bold;
            line-height: 22px;
            margin-bottom: 2px;
            font-size: 12px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            span {
              color: #00afff;
            }
          }
          p {
            color: rgba(0, 0, 0, 0.45);
            line-height: 18px;
            margin-bottom: 8px;
            font-size: 12px;
            max-height: 18px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            span {
              color: #00afff;
            }
          }
        }
      }
    }
  }
}
</style>
